import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2SubscriptionService {
    constructor(private datatask: DataTaskService) {}

    public async getSettings(): Promise<P2SubscriptionSettingsGet> {
        return (await this.datatask.Post(1179))[0];
    }

    public async listSubscriptions(): Promise<P2SubscriptionItem[]> {
        return this.datatask.Post(79);
    }

    public async getSubscription(params: GetP2SubscriptionParams): Promise<P2SubscriptionGet> {
        return (await this.datatask.Post(80, params))[0];
    }

    public async saveSubscription(subscription: P2SubscriptionGet): Promise<P2SubscriptionSaveResponse> {
        return (await this.datatask.Post(81, subscription))[0];
    }
}

export interface P2SubscriptionSettingsGet {
    searchtext: string;
}

export interface P2SubscriptionItem extends Item {
    item_state?: string;
}

export interface GetP2SubscriptionParams {
    p2_subscription_keyno: string;
}

export interface P2SubscriptionGet {
    p2_subscription_keyno: string;
    word_id_heading: string;
    word_id_heading_currentlanguage: string;
    word_id_description: string;
    word_id_description_currentlanguage: string;
    price_eur: number;
    price_locval: number;
}

export interface P2SubscriptionSaveResponse {
    iserror: '0' | '1';
    message: string;
}
